import {configureStore} from "@reduxjs/toolkit";
import projectReducer from "State/projectSlice";
import userReducer from "State/userSlice";
import generalPinDialogReducer from "State/generalPinDialogSlice";
import projectPinDialogReducer from "State/projectPinDialogSlice";
import generalPlaceablePinReducer from "State/generalPlaceablePinSlice";
import addProjectCenterPinReducer from "State/addProjectCenterPinSlice";
import editProjectCenterPinReducer from "State/editProjectCenterPinSlice";
import pinReducer from "State/pinSlice";
import addCircleReducer from "State/addCircleSlice";
import editCircleReducer from "State/editCircleSlice";
import addPinModalReducer from "State/addPinModalSlice";
import {firestoreReducer} from "redux-firestore";
import {firebaseReducer} from "react-redux-firebase";


const store = configureStore({
    reducer: {
        project: projectReducer,
        generalPinDialog: generalPinDialogReducer,
        projectPinDialog: projectPinDialogReducer,
        generalPlaceablePin: generalPlaceablePinReducer,
        addProjectCenterPin: addProjectCenterPinReducer,
        editProjectCenterPin: editProjectCenterPinReducer,
        pin: pinReducer,
        addProjectCircle: addCircleReducer,
        editProjectCircle: editCircleReducer,
        addPinModal: addPinModalReducer,
        firebase: firebaseReducer,
        firestore: firestoreReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        // Firebase gives data that is non-serializable for Redux Tookit
        // Therefor, do not try to serialize the following actions
        serializableCheck: {
            //ignoredActions: [],
            ignoredActionPaths: ['auth'],
            //ignoredPaths: [],        
        }
    }),
});


export default store;